import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y, Autoplay } from 'swiper/modules';

// Swiper core styles
import 'swiper/css';
import 'swiper/css/pagination';

const testimonials = [
  {
    quote:
      'I truly appreciate your guidance, support, and encouragement throughout my Counselling Psychology internship. It was a wonderful learning experience, and I am grateful for the opportunity to learn under your guidance. The knowledge and practical exposure I gained during the internship have been very helpful in my academic and professional journey.',
    author: ' d.pathare from Mumbai, India.'
  },
  {
    quote:
      'This was my first experience with counseling, and it turned out to be very positive. You created a comfortable space where I could open up freely, and the guidance felt practical and relevant to my situation.You understood my concerns deeply and helped me work through them at my own pace without any pressure.The session gave me a new perspective on my situation. Your insights were thoughtful and helped me reflect in a healthier way. Overall, it was a very meaningful experience. Your calm presence, patience, and clarity made a big difference for me during a difficult phase.',
    author: 'neha from Banglore, India.'
  },
  {
    quote:
      'Sometimes all we need is someone who listens without judging. Thank you for being that person for me. Your guidance has helped me understand my emotions and myself much better.',
    author: 'megha from Uttarakhand, India.'
  },
  {
    quote:
      'These two months really gave me my first real ACTUAL teaching in counselling, learning to actually sit with a client, listen without rushing to fix things, and understand where ethical boundaries come in practically, not just theoretically. The exposure to psychometric assessments and documentation under your supervision was honestly one of the most useful parts of this internship for me. I feel like I am leaving with a much clearer sense of what this work actually involves. As someone who was interested in learning in-depth about counselling psychology, this journey genuinely taught me more than I thought I had be learning. Thank you for your patience and guidance through it, really grateful for the experience!! :))',
    author: 's.satyarthi from Mumbai, India.'
  },
  {
    quote:
      'This entire Summer Internship was a wonderful experience. I actually got to learn a lot and gained really good practical knowledge. The best part about the internship was the assignments that kept me on my toes and ready with all the information to be reflected upon and ready to be applied. The interactive sessions also made the program very interesting.',
    author: 'laya M from Mumbai, India.'
  },
{
    quote: 'Thank you so much miss! It was a wonderful experience and opportunity for me. I have learnt a lot and now have developed much more interest in the field of counselling! 🤗',
    author: 'm.parab from Mumbai, India.'
  },{
    quote:
      'Thank you, ma’am, for your genuine empathy, care, and understanding. Your guidance has truly helped me change my perspective. You are a genuinely kind-hearted person, and it was wonderful being in contact with you. I’m truly grateful for your support and care.”',
    author: 'm.s from Banglore, India.'
  },{
    quote:
      'The sessions helped me understand myself in a way I never had before. Your patience, empathy, and guidance made it so much easier to open up and work through things.',
    author: 'r. from Punjab, India.'
  },{
    quote:
      'I came into the session feeling completely confused, but I left with so much more clarity. Thank you for listening without judgement and helping me see things from a different perspective',
    author: 'a.kumar from Uttarakhand, India.'
  },{
    quote:
      'Your genuine care and the way you listened made me feel completely comfortable. The guidance I received has helped me handle situations with much more confidence and understanding.',
      author: 'sneha from Karnatka, India'
  },
  {
    quote:
      'I was hesitant to talk about what I was going through, but you made the entire experience feel safe and comfortable. I’m truly grateful for the perspective and confidence I gained',
      author: 'harpreet from punjab, India'
  },
  {
    quote:
      'Sometimes all we need is someone who listens without judging. Thank you for being that person for me. Your guidance has helped me understand my emotions and myself much better.',
      author: 'megha from Uttarakhand, India'
  },

];

export default function TestimonialsSlider() {
  return (
    <div className="testimonials-swiper">
      <Swiper
        modules={[Pagination, A11y, Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        loop
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        a11y={{ prevSlideMessage: 'Previous testimonial', nextSlideMessage: 'Next testimonial' }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }}
      >
        {testimonials.map((t, idx) => (
          <SwiperSlide key={idx}>
            <article className="testimonial-card" aria-label={`Testimonial from ${t.author}`}>
              <p className="testimonial-text">“{t.quote}”</p>
              <span className="testimonial-author">— {t.author}</span>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
